import{b as o}from"./chunk-RCPA6UVN.js";async function a(i){return o("tauri",i)}export{a};
